"use client";
import DropdownIcon from "@/Components/Common/Icons/DropdownIcon";
import dayjs from "dayjs";
import React, { useState } from "react";

const Accordian = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <div className="w-full mx-auto ">
        <div className="border border-[#E1E1E1] cursor-pointer rounded-md shadow-sm">
          <div
            onClick={toggleAccordion}
            className="flex justify-between items-center w-full p-4  text-gray-800 font-semibold rounded-t-md "
          >
            <div className="text-black text-[14px] font-normal">
              {dayjs(data.submission_status_date).format(
                "MMMM DD, YYYY"
              )}{" "}
              <span className="hidden text-gray-500 text-sm">
                (Type 1 - New Molecular Entity)
              </span>
            </div>
            <span
              className={`transform transition-transform ${isOpen ? "rotate-180" : ""
                }`}
            >
              <DropdownIcon />
            </span>
          </div>

          {isOpen && (
            <div className="p-4 bg-white border-t border-gray-200">
              <div className="mb-4">
                <p className="text-[#4B4B4B] text-[14px] font-light font-poppins">
                  Class code: {data.submission_class_code_id}
                </p>
                <p className="text-[#4B4B4B] text-[14px] font-light font-poppins">
                  Type: {data.submission_type}
                </p>
                <p className="text-[#4B4B4B] text-[14px] font-light font-poppins">
                  Priority: {data.review_priority}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Accordian;
